import React from "react";
import "./UnderConstruction.scss";
import Lottie from "lottie-react";
import underConAnim from "../../lottie/underConstructionAnimation.json";
import underConstructionBG from "../../assets/under-construction.jpg";

const UnderConstruction = () => {
  return (
    <>
      <div className="under_construction">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${underConstructionBG})` }}
          ></div>
          <div className="heading_box">Under Construction</div>

          <div className="under_construction_content">
            <div className="">
              <div className="row justify-content-center">
                <div className="col-lg-6">
                  <div className="left">
                    <Lottie animationData={underConAnim} loop={true}></Lottie>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-6">
                  <div className="right mt-5">
                    <h3>COMING SOON</h3>
                    <h4>
                      This page is under construction, follow us for more
                      update!
                    </h4>
                    <h5>Thank You.</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnderConstruction;
